export const EVENTS_FEATURE_KEY = 'events';
